module.exports = __webpack_public_path__ + "img/banner_contact.6e046863.jpg";